export default __webpack_public_path__ + "static/media/icon_circle_white.c1027929.svg";